module.exports = __webpack_public_path__ + "img/plus-circle.04d73c37.png";